var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"analytics-totals"},_vm._l((_vm.cards),function(card){return _c('kpi-card',{key:card.key,attrs:{"label":card.label,"value":card.value,"highlight":card.highlight}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }